import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import infoList from "@/mixins/infoList";
import { ipUserCountList } from "@/api/role";
import DataOptions from "../../components/timeList/dataOptions.vue";
import BanRoleByIp from "./components/banRoleByIp.vue";
import BanAccountByIp from "./components/banAccountByIp.vue";
export default {
  components: {
    DataOptions: DataOptions,
    BanRoleByIp: BanRoleByIp,
    BanAccountByIp: BanAccountByIp
  },
  name: "ipCount",
  mixins: [infoList],
  data: function data() {
    return {
      roleListDialog: false,
      accountListDialog: false,
      listApi: ipUserCountList,
      searchInfo: {},
      ip: "",
      sdate: "",
      edate: "",
      timedata: [this.$moment().subtract(14, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")]
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.searchInfo.sdate = _this.timedata[0];
            _this.searchInfo.edate = _this.timedata[1];
            _this.getTableData();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    //改变switch开关
    changeWords: function changeWords(row, e) {
      if (e == false) {
        row.type = "";
        row.Forbidden_words = "";
      }
    },
    //直接调查询接口
    queryEvent: function queryEvent() {
      this.searchInfo.sdate = this.timedata[0];
      this.searchInfo.edate = this.timedata[1];
      this.getTableData();
      if (this.tableData.length === 0) {
        this.$message({
          message: "暂无数据"
        });
      }
    },
    getRoleListByIp: function getRoleListByIp(ip) {
      this.sdate = this.timedata[0];
      this.edate = this.timedata[1];
      this.ip = ip;
      this.roleListDialog = true;
    },
    getAccountListByIp: function getAccountListByIp(ip) {
      this.sdate = this.timedata[0];
      this.edate = this.timedata[1];
      this.ip = ip;
      this.accountListDialog = true;
    },
    banRoleFinish: function banRoleFinish() {
      this.roleListDialog = false;
      this.getTableData();
    },
    banAccountFinish: function banAccountFinish() {
      this.accountListDialog = false;
      this.getTableData();
    },
    banIp: function banIp() {}
  }
};